const BigCursor = () => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="96" height="96" rx="48" />
      <path
        d="M21.4587 32.5075L33.0857 69.9723C35.8389 78.8673 48.3765 78.9944 51.3204 70.1629L54.7513 59.8702C55.7043 57.0111 57.9492 54.7662 60.8083 53.8131L71.1011 50.3822C79.9325 47.4384 79.7843 34.9219 70.9105 32.1475L33.4457 20.5205C26.0756 18.2332 19.1714 25.1374 21.4587 32.5075Z"
        stroke="black"
        strokeWidth="5.02022"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BigCursor;
